
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const vh = () => window.innerHeight;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

  /* ── catalog (live-refreshed when served from rarely.co) ── */
  const FLAVORS = {
    peach: { label: 'Peach', color: 'var(--peach)' },
    apple: { label: 'Green Apple', color: 'var(--apple)' },
    rasp:  { label: 'Raspberry Lemonade', color: 'var(--rasp)' },
    grape: { label: 'Grape', color: 'var(--grape)' },
  };
  const ORDER = ['peach', 'apple', 'rasp', 'grape'];
  const FORMULAS = {
    nc: { label: 'No Caffeine', tags: ['10g ketones', '0mg caffeine', '0g sugar'], items: {
      grape: { handle: 'ketone-iq-no-caffeine-shot-brain-fuel-supplement-0g-sugar', id: 44296889008227, price: null, available: false, status: 'loading', shots: 6 },
      apple: { handle: 'ketone-iq-no-caffeine-shot-green-apple-brain-fuel-12-pack', id: 44296907325539, price: null, available: false, status: 'loading', shots: 6 },
      peach: { handle: 'ketone-iq-peach-shot-no-caffeine-no-sugar-12-or-24-pack', id: 44296903065699, price: null, available: false, status: 'loading', shots: 6 },
      rasp:  { handle: 'ketone-iq-no-caffeine-shot-raspberry-lemonade-12-or-24-pack', id: 44296896413795, price: null, available: false, status: 'loading', shots: 6 },
    }},
    caf: { label: '+Caffeine', tags: ['5g ketones', '100mg natural caffeine', '0g sugar'], items: {
      grape: { handle: 'ketone-iq-caffeine-shot-grape-sugar-free-energy-12-or-24-count', id: 44296904638563, price: null, available: false, status: 'loading', shots: 6 },
      apple: { handle: 'ketone-iq-caffeine-shot-green-apple-sugar-free-energy', id: 44296900608099, price: null, available: false, status: 'loading', shots: 6 },
      peach: { handle: 'ketone-iq-caffeine-shot-peach-sugar-free-energy', id: 44296893759587, price: null, available: false, status: 'loading', shots: 6 },
      rasp:  { handle: 'ketone-iq-caffeine-shot-raspberry-lemonade-sugar-free-energy', id: 44296912273507, price: null, available: false, status: 'loading', shots: 6 },
    }},
  };
  const ROOT = window.Shopify?.routes?.root || '/';
  const route = path => ROOT + path;
  const img = (fm, fl) => window.KIQ_IMAGES[`${fm}-${fl}`];
  const money = c => Number.isFinite(c) ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(c / 100) : '—';
  let busy = false;
  let loading = true;
  const allItems = () => Object.values(FORMULAS).flatMap(f => Object.values(f.items));
  async function request(path, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const r = await fetch(route(path), {credentials:'same-origin',cache:'no-store',...options,signal:controller.signal});
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Shopify is unavailable. Please try again.');
      return data;
    } finally { clearTimeout(timer); }
  }
  async function hydrate(it) {
    try {
      const p = await request(`products/${it.handle}.js?kiq=${Date.now()}`);
      const v = p.variants?.find(v => String(v.id) === String(it.id));
      if (!v || !Number.isInteger(v.price) || v.price < 0 || !Array.isArray(v.options) || !v.options.includes('6 Shots')) throw new Error('This exact six-shot pack could not be verified.');
      it.price = v.price; it.available = v.available === true; it.status = it.available ? 'ready' : 'soldout';
      return it;
    } catch (err) { it.available = false; it.price = null; it.status = 'error'; throw err; }
  }
  function controls() {
    const it = cur(), a = firstAvailable('nc', state.fl), b = firstAvailable('caf', state.fl);
    const label = busy ? 'Updating cart…' : loading ? 'Checking stock…' : it.status === 'error' ? 'Unavailable — retry below' : !it.available ? 'Sold out' : `Add to cart — ${money(it.price * state.qty)}`;
    ['#addBtn','#sbAdd'].forEach(s => { $(s).disabled = busy || loading || !it.available; $(s).textContent = label; });
    $('#kitBtn').disabled = busy || loading || !a || !b;
    $('#kitBtn').textContent = busy ? 'Updating cart…' : loading ? 'Checking stock…' : a && b ? 'Add both' : 'Starter unavailable';
    $('#stockRetry').disabled = busy || loading;
    $('#qMinus').disabled = busy || state.qty <= 1; $('#qPlus').disabled = busy || state.qty >= 10;
    $$('.fm, .fl, [data-pick]').forEach(b => { b.disabled = busy; });
  }
  const state = { fm: 'nc', fl: 'peach', qty: 1 };
  const cur = () => FORMULAS[state.fm].items[state.fl];

  /* ── configurator ── */
  const flWrap = $('#flavors');
  function buildFlavors() {
    flWrap.innerHTML = '';
    ORDER.forEach(k => {
      const it = FORMULAS[state.fm].items[k];
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'fl' + (it.available ? '' : ' out');
      b.setAttribute('role', 'radio'); b.dataset.fl = k;
      b.style.setProperty('--fc', FLAVORS[k].color);
      b.setAttribute('aria-checked', String(k === state.fl));
      b.disabled = busy;
      b.setAttribute('aria-label', FLAVORS[k].label + (it.available ? '' : it.status === 'loading' ? ' — checking stock' : it.status === 'error' ? ' — unavailable' : ' — sold out'));
      b.innerHTML = `<img src="${img(state.fm, k)}" alt="" loading="lazy"><span>${FLAVORS[k].label}</span>`;
      b.addEventListener('click', () => select(state.fm, k));
      flWrap.appendChild(b);
    });
  }
  function firstAvailable(fm, pref) {
    if (FORMULAS[fm].items[pref].available) return pref;
    return ORDER.find(k => FORMULAS[fm].items[k].available) || null;
  }
  let lastBottle = '';
  function select(fm, fl, opts = {}) {
    if (busy) return;
    const note = '';
    state.fm = fm; state.fl = fl;
    if (!opts.finder) $('#fresult').classList.remove('on');
    $('#oosNote').textContent = note;
    $$('.fm').forEach(b => b.setAttribute('aria-checked', String(b.dataset.fm === fm)));
    buildFlavors();
    render(opts);
  }
  function render() {
    const f = FORMULAS[state.fm], fl = FLAVORS[state.fl], it = cur();
    const stage = $('#stage'), bottle = $('#stageBottle'), src = img(state.fm, state.fl);
    stage.style.setProperty('--fc', fl.color);
    const word = $('#stageWord'); word.textContent = fl.label.replace('Raspberry Lemonade', 'Rasp. Lemonade');
    word.classList.toggle('long', fl.label.length > 6);
    $('#stageBadge').textContent = f.label;
    $('#stageTags').innerHTML = f.tags.map(t => `<span>${t}</span>`).join('');
    if (src !== lastBottle) {
      if (lastBottle) { bottle.classList.add('swap'); setTimeout(() => { bottle.src = src; bottle.onload = () => bottle.classList.remove('swap'); setTimeout(() => bottle.classList.remove('swap'), 300); }, 180); }
      else bottle.src = src;
      bottle.alt = `Ketone-IQ ${f.label} ${fl.label} shot`;
      lastBottle = src;
    }
    $('#fmLabel').textContent = f.label; $('#flLabel').textContent = fl.label;
    const total = it.price === null ? null : it.price * state.qty, shots = it.shots * state.qty;
    $('#qty').textContent = state.qty;
    $('#qtyLabel').textContent = `${shots} shots`;
    $('#price').textContent = money(total);
    $('#per').textContent = `${shots} shots · ${money(it.price === null ? null : it.price / it.shots)} / shot`;
    $('#addBtn').textContent = `Add to cart — ${money(total)}`;
    // sticky bar
    $('#sbImg').src = src; $('#sbName').textContent = `${f.label} · ${fl.label}`;
    $('#sbMeta').textContent = `${shots} shots · ${money(total)}`;
    // kit
    const kA = firstAvailable('nc', state.fl), kB = firstAvailable('caf', state.fl);
    if (kA && kB) {
      $('#kitA').src = img('nc', kA); $('#kitB').src = img('caf', kB);
      const kitName = kA === kB ? `in ${FLAVORS[kA].label}` : `(${FLAVORS[kA].label} + ${FLAVORS[kB].label})`;
      $('#kitTxt').textContent = `One No Caffeine + one +Caffeine pack ${kitName}. 12 shots to find your formula — ${money(FORMULAS.nc.items[kA].price + FORMULAS.caf.items[kB].price)}.`;
    } else $('#kitTxt').textContent = loading ? 'Checking both six-shot packs…' : 'Both formulas must be available to build the Two-Fuel Starter.';
    controls();
  }
  $$('.fm').forEach(b => b.addEventListener('click', () => select(b.dataset.fm, state.fl)));
  $('#qMinus').addEventListener('click', () => { state.qty = Math.max(1, state.qty - 1); render(); });
  $('#qPlus').addEventListener('click', () => { state.qty = Math.min(10, state.qty + 1); render(); });

  /* persona cards preselect */
  $$('[data-pick]').forEach(b => b.addEventListener('click', () => {
    const [fm, fl] = b.dataset.pick.split(':');
    select(fm, fl);
    $('#shop').scrollIntoView({ behavior: 'smooth' });
  }));

  /* fuel finder */
  const ans = {};
  $$('.fq').forEach(q => $$('button', q).forEach(b => b.addEventListener('click', () => {
    $$('button', q).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
    ans[q.dataset.q] = b.dataset.v;
    if (ans.when && ans.caf) {
      const caf = ans.caf === 'none' && ans.when !== 'pm';
      const fm = caf ? 'caf' : 'nc';
      const why = caf
        ? (ans.when === 'am' ? 'It folds your morning caffeine and your ketones into one 2 oz shot.' : 'You get 100mg of caffeine for the start line plus 5g of ketones for the long part.')
        : (ans.caf === 'avoid' ? 'All fuel, zero stimulant — 10g of ketones and nothing to keep you up.'
          : ans.caf === 'had' ? 'You\'ve already had your caffeine. This adds 10g of ketones without stacking more.'
          : 'Later in the day, skip the stimulant and take the full 10g of ketones.');
      const r = $('#fresult');
      r.innerHTML = `Your fuel: <b>${FORMULAS[fm].label}</b>. ${why} We've selected it below.`;
      r.classList.add('on');
      select(fm, state.fl, { finder: true });
    }
  })));

  /* ── cart ── */
  const toast = $('#toast');
  let toastT;
  function showToast(name, src) {
    $('#tName').textContent = name; $('#tImg').src = src;
    toast.classList.add('on'); clearTimeout(toastT);
    toastT = setTimeout(() => toast.classList.remove('on'), 9000);
  }
  $('#toastX').addEventListener('click', () => toast.classList.remove('on'));
  $('#tKeep').addEventListener('click', () => toast.classList.remove('on'));
  async function refreshCount() {
    try { const c = await request('cart.js'); $('#cartCount').textContent = c.item_count; } catch (_) {}
  }
  async function addItems(items, name, src) {
    if (busy || loading || items.some(i => !i.item.available || !Number.isInteger(i.quantity) || i.quantity < 1 || i.quantity > 10)) return;
    busy = true; controls(); $('#oosNote').textContent = ''; toast.classList.remove('on');
    let posted = false;
    try {
      const prices = items.map(i => i.item.price);
      await Promise.all(items.map(i => hydrate(i.item)));
      if (items.some(i => !i.item.available)) throw new Error('A selected pack just sold out. Please choose an available flavor.');
      if (items.some((i,n) => i.item.price !== prices[n])) throw new Error('The price changed. Review the updated price and add again.');
      const before = await request('cart.js');
      if (!Array.isArray(before.items)) throw new Error('Could not verify your cart. Please open your cart before trying again.');
      posted = true;
      const added = await request('cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items.map(i => ({id:i.item.id,quantity:i.quantity}))})});
      if (!Array.isArray(added.items)) throw new Error('Could not confirm the cart update.');
      const after = await request('cart.js');
      const count = (cart,id) => cart.items.filter(x => String(x.variant_id) === String(id) && !x.selling_plan_allocation).reduce((s,x) => s + x.quantity,0);
      if (!Array.isArray(after.items) || items.some(i => count(after,i.item.id) !== count(before,i.item.id) + i.quantity)) throw new Error('The cart quantity could not be confirmed.');
      $('#cartCount').textContent = after.item_count;
      $('#tCheckout').href = route('checkout'); showToast(name, src);
    } catch (err) {
      $('#oosNote').textContent = (err.name === 'AbortError' ? 'The request timed out.' : err.message) + (posted ? ' Check your cart before trying again; it may have changed.' : '');
    } finally { busy = false; render(); buildFlavors(); }
  }
  const addCurrent = () => {
    const it = cur();
    return addItems([{item:it,quantity:state.qty}], `${state.qty} × ${FORMULAS[state.fm].label} · ${FLAVORS[state.fl].label} (${it.shots * state.qty} shots)`, img(state.fm,state.fl));
  };
  $('#addBtn').addEventListener('click', addCurrent);
  $('#sbAdd').addEventListener('click', addCurrent);
  $('#sbInfo').addEventListener('click', () => $('#shop').scrollIntoView({behavior:'smooth'}));
  $('#kitBtn').addEventListener('click', () => {
    const a = firstAvailable('nc',state.fl), b = firstAvailable('caf',state.fl);
    if (!a || !b) return;
    addItems([{item:FORMULAS.nc.items[a],quantity:1},{item:FORMULAS.caf.items[b],quantity:1}], `Two-Fuel Starter · ${FLAVORS[a].label} + ${FLAVORS[b].label} — 12 shots`, img('nc',a));
  });
  async function live() {
    if (busy) return;
    loading = true; controls();
    await Promise.allSettled(allItems().map(hydrate));
    loading = false; render(); buildFlavors();
    $('#oosNote').textContent = allItems().some(i => i.status === 'error') ? 'Some packs could not be verified. Unverified packs cannot be purchased. Retry stock or choose a verified flavor.' : '';
  }
  $('#stockRetry').addEventListener('click',live);
  $('#cartPill').href = route('cart'); $('#tCheckout').href = route('checkout');
  select('nc','peach'); live(); refreshCount();

  /* ── reveals ── */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }) : null;
  const revealables = $$('.rv, .ch-word, .tank, .timeline, .runway');
  if (io) revealables.forEach(el => io.observe(el)); else revealables.forEach(el => el.classList.add('in'));

  /* wall lines light as they cross center */
  const wallLines = $$('.walls li');

  /* ── curve chart ── */
  const X0 = 56, X1 = 616, Y0 = 318, Y1 = 22, TMAX = 4, YMAX = 1.15;
  const sx = t => X0 + (t / TMAX) * (X1 - X0);
  const sy = v => Y0 - (v / YMAX) * (Y0 - Y1);
  const ket = t => 0.18 + 0.78 * (1 - Math.exp(-t / 0.3)) * (t < 0.9 ? 1 : Math.exp(-(t - 0.9) / 5.2));
  const sug = t => 0.18 + 0.9 * Math.exp(-Math.pow((t - 0.38) / 0.17, 2)) - 0.14 * Math.exp(-Math.pow((t - 1.05) / 0.32, 2));
  (function axes() {
    const g = $('#cgrid'), a = $('#caxis'); let gs = '', as = '';
    for (let h = 0; h <= TMAX; h++) { gs += `<line x1="${sx(h)}" x2="${sx(h)}" y1="${Y1}" y2="${Y0}"/>`; as += `<text x="${sx(h)}" y="${Y0 + 22}" text-anchor="${h === 0 ? 'start' : h === TMAX ? 'end' : 'middle'}">${h === 0 ? 'Shot' : h + ' hr'}</text>`; }
    gs += `<line x1="${X0}" x2="${X1}" y1="${Y0}" y2="${Y0}" style="stroke:rgba(13,14,17,.3)"/>`;
    gs += `<line x1="${X0}" x2="${X1}" y1="${sy(0.18)}" y2="${sy(0.18)}" style="stroke-dasharray:4 5"/>`;
    as += `<text x="${X0 - 10}" y="${sy(0.18) + 4}" text-anchor="end">Base</text><text x="${X0 - 10}" y="${Y1 + 8}" text-anchor="end">Fuel</text>`;
    g.innerHTML = gs; a.innerHTML = as;
  })();
  const pathTo = (fn, t) => { let d = ''; const n = Math.max(2, Math.ceil(t / TMAX * 220)); for (let i = 0; i <= n; i++) { const tt = t * i / n; d += (i ? 'L' : 'M') + sx(tt).toFixed(1) + ' ' + sy(fn(tt)).toFixed(1); } return d; };
  const STEP_T = [0, 0.33, 0.75, 2.0, 4.0];
  const steps = $$('#steps li');
  function placeAnn(id, t, v, dx = 10, dy = -34) {
    const g = $(id), w = +$('rect', g).getAttribute('width') || 150; g.setAttribute('transform', `translate(${Math.max(X0, Math.min(sx(t) + dx, X1 - w))},${sy(v) + dy})`);
  }
  function drawCurve(t) {
    t = clamp(t, 0.001, TMAX);
    $('#kpath').setAttribute('d', pathTo(ket, t));
    $('#spath').setAttribute('d', pathTo(sug, t));
    $('#kshade').setAttribute('d', pathTo(ket, t) + `L${sx(t).toFixed(1)} ${Y0}L${X0} ${Y0}Z`);
    const x = sx(t);
    $('#nowline').setAttribute('x1', x); $('#nowline').setAttribute('x2', x);
    $('#kdot').setAttribute('cx', x); $('#kdot').setAttribute('cy', sy(ket(t)));
    $('#sdot').setAttribute('cx', x); $('#sdot').setAttribute('cy', sy(sug(t)));
    const mins = Math.round(t * 60), hh = Math.floor(mins / 60), mm = String(mins % 60).padStart(2, '0');
    $('#clock').textContent = `T+${hh}:${mm}`;
    $('#annCrash').classList.toggle('on', t > 1.0);
    $('#annRise').classList.toggle('on', t > 0.45 && t < 1.6);
    $('#annHold').classList.toggle('on', t > 1.7);
    let idx = 0; for (let i = 0; i < 4; i++) if (t >= STEP_T[i] - 0.001) idx = i;
    steps.forEach((s, i) => s.classList.toggle('on', i === idx));
  }
  function sizeAnns() {
    const small = window.innerWidth <= 860, h = small ? 34 : 24;
    ['#annCrash', '#annRise', '#annHold'].forEach(id => {
      const g = $(id), t = $('text', g), r = $('rect', g);
      const w = Math.ceil(t.getComputedTextLength()) + 20;
      r.setAttribute('width', w); r.setAttribute('height', h); t.setAttribute('y', small ? 24 : 16);
    });
    placeAnn('#annCrash', 1.05, sug(1.05), small ? -80 : -52, small ? -54 : -40);
    placeAnn('#annRise', 0.5, ket(0.5), 14, small ? -52 : -40);
    placeAnn('#annHold', 2.6, ket(2.6), small ? -150 : -60, small ? -56 : -42);
  }
  sizeAnns(); window.addEventListener('resize', sizeAnns);
  drawCurve(0.001);

  /* ── nav, gauge, sticky bar, scroll-driven bits ── */
  const nav = $('#nav'), hero = $('#top'), shop = $('#shop'), sbar = $('#sbar'), finale = $('.finale');
  const chapters = $$('.gauge a').map(a => ({ a, el: document.getElementById(a.dataset.ch), bar: $('.bar i', a) }));
  let ticking = false;
  function onScroll() {
    ticking = false;
    const H = vh();
    const hb = hero.getBoundingClientRect().bottom;
    nav.classList.toggle('solid', hb < 70);
    nav.classList.toggle('dim', hb >= 70 && window.scrollY > 24);
    chapters.forEach(c => {
      const r = c.el.getBoundingClientRect();
      const p = clamp((H * 0.5 - r.top) / r.height, 0, 1);
      c.bar.style.setProperty('--p', p.toFixed(3));
      c.a.classList.toggle('on', p > 0 && p < 1);
    });
    // wall lines
    wallLines.forEach(li => { const r = li.getBoundingClientRect(); if (r.top < H * 0.62) li.classList.add('lit'); else li.classList.remove('lit'); });
    // curve: piecewise map scroll through steps → time
    const stepsEl = $('#steps'), sr = stepsEl.getBoundingClientRect();
    const anchor = H * (window.innerWidth <= 860 ? 0.82 : 0.55);
    const p = clamp((anchor - sr.top) / sr.height, 0, 0.9999);
    const seg = Math.floor(p * 4), f = p * 4 - seg;
    drawCurve(STEP_T[seg] + (STEP_T[seg + 1] - STEP_T[seg]) * f);
    // sticky bar: after hero, hide around shop + finale
    const sR = shop.getBoundingClientRect(), fR = finale.getBoundingClientRect();
    const inShop = sR.top < H * 0.9 && sR.bottom > H * 0.1;
    const inFinale = fR.top < H * 0.6;
    const show = hero.getBoundingClientRect().bottom < 0 && !inShop && !inFinale;
    sbar.classList.toggle('on', show); sbar.setAttribute('aria-hidden', String(!show));
  }
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();
